export { default } from "./AdminApp";
